import { commonViewTexts } from '../common';
import { editDialogCommonViewTexts } from './edit-dialog-common';

const targetName = commonViewTexts.project;

export const editProjectDialogViewTexts = {
  title: `${targetName} 編集`,
  description1: editDialogCommonViewTexts.description1(targetName),
  description2: editDialogCommonViewTexts.description2,
  label: `${targetName}名`,
  cancel: editDialogCommonViewTexts.cancel,
  ok: editDialogCommonViewTexts.ok
} as const;
